import { SPACE_POST_LIST_ACTION } from 'core/constants/Actions'
import { Action } from 'core/models/ActionTypes'
import { SpacePost } from 'core/models/Space'

const intialState: { spacePosts: SpacePost[], count: number, currentPage: number, isLoading: boolean } = {
  spacePosts: [],
  isLoading: false,
  count: 0,
  currentPage: 0
}

interface ActionType extends Action {
  payload: {
    spacePosts: SpacePost[];
    count: number;
    currentPage: number;
  }
}

export default function spacePostListReducer(state = intialState, action: ActionType) {

  switch (action.type) {
    case SPACE_POST_LIST_ACTION.REQUEST:
      return { ...state, isLoading: true }

    case SPACE_POST_LIST_ACTION.SUCCESS:
      const { spacePosts, count, currentPage } = action.payload;
      return { ...state, spacePosts, count, currentPage, isLoading: false }

    case SPACE_POST_LIST_ACTION.FAILURE:
      return { ...state, ...intialState }

    default:
      return state
  }
}